<div class="client_pageBody space_book_page lg:max-w-[500px] space-y-10" *ngIf="object">
  <div class="flex flex-col items-center space-y-4">
    <div>
      <img src="/silone/silone_shake.png" style="height: 120px;" />
    </div>
    <div class="font-bold text-2xl text-center">
      {{_common.invite_exceeded_error}}
    </div>
  </div>

  <!-- <div>{{object.id}}</div> -->
  <div class="card">
    <div class="cardBody">
      <div>{{_common.Location}}: {{lang(object.space.location.name,object.space.location.name_lang)}}</div>
      <div>{{_common.address}}: {{lang(object.space.location.address,object.space.location.address_lang)}}</div>
      <div>{{_common.Space}}: {{lang(object.space.name,object.space.name_lang)}}</div>
      <div>{{_common.date}}: {{formatLongDate(session.lang, object.startTime)}}</div>
      <div>{{_common.time}}: {{formatDisplayTime(this.session.lang,object.startTime)}}-
        {{formatDisplayTime(this.session.lang,object.endTime)}}
        ({{formatMins(object.durationMins,_common)}})</div>
    </div>
  </div>

  <div class=" mt-4 w-full flex justify-center">
    <a [routerLink]="[session.path('/home')]">
      <div class="client_button">{{_common.backtoHome}}</div>
    </a>

  </div>


</div>